<template>
  <div class="eu-flex eu-justify_space-between eu-align-items_center">
    <div class="eu-flex-item eu-basis_12 eu-basis_5_lg">
      <p class="emd-text _type_label _size_tiny eu-mb_1">
        {{ paymentMethod }}
        <span v-if="brand"> - {{ brand }}</span>
      </p>
    </div>

    <div
      v-if="brand"
      class="eu-flex-item eu-basis_12 eu-basis_5_lg"
    >
      <jade-brand
        :use="brand"
        size="xlarge"
      />
    </div>
  </div>
</template>

<script>
import { JadeBrand } from '@jade'

export default {
  name: 'ChargesPaymentMethodLastTransactionInfos',
  components: {
    JadeBrand
  },
  props: {
    lastTransactionId: {
      required: true
    },
    lastTransactionCard: {
      required: true
    },
    paymentMethod: {
      required: true
    }
  },

  computed: {
    brand () {
      return this.lastTransactionCard?.brand.toLowerCase() ?? ''
    }
  }
}
</script>
